export const QUESTION_TYPE = {
    TEXT: 'text',
    TEXTAREA: 'textarea',
    RADIO: 'radio',
    CHECKBOX: 'checkbox',
    DROPDOWN: 'dropdown',
    RATING: 'rating',
    DATE: 'date',
    TIME: 'time',
    NUMBER: 'number',
    EMAIL: 'email',
    PHONE: 'phone',
    URL: 'url',
}

export const NAME_REGEX = /^[A-Za-z\s-]+$/;
export const CITY_REGEX = /^[A-Za-z\s.-]+$/;
export const EMAIL_REGEX =  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PHONE_REGEX =  /^\+?[0-9\s\-()]{7,20}$/;    

export const VALIDATION_CONFIG = {
    1: { // Name
      type: 'name',
      min: 2,
      max: 50,
      allowBlankWhenAnonymous: true,
      regex: [NAME_REGEX]
    },
    4: { // City
      type: 'city',
      min: 2,
      max: 30,
      regex: [CITY_REGEX]
    },
    5: { // Contact
      type: 'contact',
      regex: [EMAIL_REGEX, PHONE_REGEX]
    },
    8: { // What did you learn about the Harappan Civilisation today?
      min: 2,
      max: 1000
    },
    9: { // What did you learn about the ancient world today that completely surprised you?
      min: 2,
      max: 1000
    },
    10: { // Does anything from the ancient times remind you of your life today? How so?
      min: 2,
      max: 1000
    },
    11: { // Is there one artefact from the exhibition you would like to keep?
      min: 2,
      max: 1000
    },
    12: { // Describe the exhibition in one unique word. Get creative!
      min: 2,
      max: 1000
    },
    13: { // If you have anything more to add, please share here
      min: 2,
      max: 1000
    }
  };
  